import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import DispatchPage from '../dispatch-page/dispatch-page.container';
import ExistingClient from '../intermediary-pages/existing-client/existing-client.container';
import Merchants from '../intermediary-pages/merchants/merchants.container';
import RedirectPage from '../redirect-page/redirect-page.container';
import ProspectsPage from '../prospects-page/prospects-page.container';
import ContactFormPage from '../contact-form-page/contact-form-page.container';
import SuccessPage from '../success-page/success-page';

const MainSwitch: React.FunctionComponent = () => {
  const { url: currentUrl } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${currentUrl}/`} exact>
        <DispatchPage />
      </Route>
      <Route path={`${currentUrl}existing-client`} exact>
        <ExistingClient />
      </Route>
      <Route path={`${currentUrl}merchants`} exact>
        <Merchants />
      </Route>
      <Route path={`${currentUrl}prospects`} exact>
        <ProspectsPage />
      </Route>
      <Route path={`${currentUrl}cardholders`} exact>
        <ContactFormPage type="umer" />
      </Route>
      <Route path={`${currentUrl}fmer-contact-form`} exact>
        <ContactFormPage type="fmer" />
      </Route>
      <Route path={`${currentUrl}er1-contact-form`} exact>
        <ContactFormPage type="er_one" />
      </Route>
      <Route path={`${currentUrl}partner-contact-form`} exact>
        <ContactFormPage type="partner_prospects" />
      </Route>
      <Route path={`${currentUrl}erde-contact-form`} exact>
        <ContactFormPage type="erde" />
      </Route>
      <Route path={`${currentUrl}eb-user-contact-form`} exact>
        <ContactFormPage type="eb_user" />
      </Route>
      <Route path={`${currentUrl}eb-client-contact-form`} exact>
        <ContactFormPage type="eb_client" />
      </Route>
      <Route path={`${currentUrl}success`} exact>
        <SuccessPage />
      </Route>
      <Route path={`${currentUrl}redirect`} exact>
        <RedirectPage />
      </Route>
    </Switch>
  );
};
export default MainSwitch;
